import React from "react";
import Menu from "../menu";
import StatusSelect from "src/components/atoms/status-select";
import useFormattedDate from "src/hooks/useFormattedDate";
import { formatQuotationReference } from "src/helpers";

export const columns = (handleOpenDeleteModal: any) => {
  return [
    {
      headerName: "Reference No.",
      field: "reference_no",
      width: 100,
      headerClass: "", // Add this line
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
      cellRenderer: ({ value, data }: any) => {
        console.log(value, "rows>>>");
        return (
          <p className="cursor-pointer">{formatQuotationReference(data)}</p>
        );
      },
    },
    {
      headerName: "Creation date",
      field: "created_at",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
      cellRenderer: ({ value }: any) => (
        <span>
          {useFormattedDate(value).split(",")[0] +
            ", " +
            useFormattedDate(value).split(",")[1]}
        </span>
      ),
    },
    {
      headerName: "Origin",
      field: "source_country",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
    },
    {
      headerName: "Destination",
      field: "destination_country",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
    },
    {
      headerName: "MOT",
      field: "mode_of_transport",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
      valueGetter: (params: any) => params.data.mode_of_transport.toUpperCase(),
    },
    {
      headerName: "Service Type",
      field: "service_type",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      minWidth: 200,
      valueGetter: (params: any) => params.data.service_type.toUpperCase(),
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      suppressMovable: true,
      editable: false,
      suppressNavigable: true,
      cellStyle: { paddingLeft: 5, paddingRight: 5 },
      minWidth: 150,
      resizable: true,
      cellRenderer: (params: any) => {
        return <StatusSelect value={params.data.status} id={params.data.id} />;
      },
    },
    {
      headerName: "Actions",
      field: "",
      lockPosition: "right",
      suppressNavigable: true,
      resizable: false,
      width: 80,
      cellRenderer: (params: any) => (
        <Menu params={params} handleOpenDeleteModal={handleOpenDeleteModal} />
      ),
      cellStyle: { paddingLeft: 12, paddingRight: 12 },
      sortable: false,
    },
  ];
};
